export const TableColumns = [
	{ title: "I - Key Scale", id: "index"},
	{ title: "0",      id: "0"},
	{ title: "1",      id: "1"},
	{ title: "2",      id: "2"},
	{ title: "3",      id: "3"},
	{ title: "4",      id: "4"},
	{ title: "5",      id: "5"},
	{ title: "6",      id: "6"},
	{ title: "7",      id: "7"},
	{ title: "8",      id: "8"},
	{ title: "9",      id: "9"},
	{ title: "10",     id: "10"},
	{ title: "11",     id: "11"},
	{ title: "12",     id: "12"},
	{ title: "13",     id: "13"},
	{ title: "14",     id: "14"},
	{ title: "15",     id: "15"},
	{ title: "16",     id: "16"},
	{ title: "17",     id: "17"},
	{ title: "18",     id: "18"},
	{ title: "19",     id: "19"},
	{ title: "20",     id: "20"},
	{ title: "21",     id: "21"},
	{ title: "22",     id: "22"},
	{ title: "23",     id: "23"},
	{ title: "24",     id: "24"},
	{ title: "25",     id: "25"},
	{ title: "26",     id: "26"},
	{ title: "27",     id: "27"},
	{ title: "28",     id: "28"},
	{ title: "29",     id: "29"},
	{ title: "30",     id: "30"},
	{ title: "31",     id: "31"},
	{ title: "32",     id: "32"},
	{ title: "32 bis", id: "33"},
	{ title: "31 bis", id: "34"}
];

export const TableIndex = [
	"index",
	"0",      
	"1",
	"2",
	"3",
	"4",
	"5",
	"6",
	"7",
	"8",
	"9",
	"10",
	"11",
	"12",
	"13",
	"14",
	"15",
	"16",
	"17",
	"18",
	"19",
	"20",
	"21",
	"22",
	"23",
	"24",
	"25",
	"26",
	"27",
	"28",
	"29",
	"30",
	"31",
	"32",
	"33",
	"34"
];
